import React, { useState, useEffect } from 'react';
import { Calendar, Smartphone } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';
import api from '../../../services/api';

const FiltrosPeriodo = ({ filtros, onChange }) => {
  const { darkMode } = useTheme();
  const [instancias, setInstancias] = useState([]);

  const user = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    api.get(`/instancias-whatsapp?cliente_id=${user.cliente_id}`)
      .then(res => setInstancias(res.data || []))
      .catch(() => {});
  }, []);

  const presets = [
    { label: '7 dias', dias: 7 },
    { label: '15 dias', dias: 15 },
    { label: '30 dias', dias: 30 },
    { label: '60 dias', dias: 60 },
    { label: '90 dias', dias: 90 },
  ];

  const handlePreset = (dias) => {
    const dataFim = new Date();
    const dataInicio = new Date();
    dataInicio.setDate(dataInicio.getDate() - dias);
    onChange({ ...filtros, dataInicio: dataInicio.toISOString().split('T')[0], dataFim: dataFim.toISOString().split('T')[0] });
  };

  const getActiveDias = () => {
    if (!filtros.dataInicio || !filtros.dataFim) return null;
    const diff = Math.round((new Date(filtros.dataFim) - new Date(filtros.dataInicio)) / (1000 * 60 * 60 * 24));
    return presets.find(p => p.dias === diff)?.dias || null;
  };

  const activeDias = getActiveDias();

  const inputCls = `px-2 py-1 sm:px-3 sm:py-1.5 rounded-lg border text-xs sm:text-sm ${darkMode ? 'bg-zinc-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'}`;

  return (
    <div className={`p-3 sm:p-4 rounded-lg border ${darkMode ? 'bg-zinc-800 border-gray-700' : 'bg-white border-gray-200'}`}>
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex flex-wrap gap-2">
          {presets.map((preset) => (
            <button key={preset.dias} onClick={() => handlePreset(preset.dias)}
              className={`px-2 py-1 sm:px-3 sm:py-1.5 rounded-lg text-xs sm:text-sm font-medium transition-colors ${
                activeDias === preset.dias
                  ? 'bg-blue-600 text-white'
                  : darkMode ? 'bg-zinc-700 hover:bg-zinc-600 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-900'
              }`}>
              {preset.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3 flex-wrap">
          {/* Filtro instância */}
          {instancias.length > 1 && (
            <div className="flex items-center gap-1.5">
              <Smartphone className={`w-4 h-4 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`} />
              <select value={filtros.instanciaId || ''}
                onChange={(e) => onChange({ ...filtros, instanciaId: e.target.value || undefined })}
                className={inputCls}>
                <option value="">Todas instâncias</option>
                {instancias.map(i => (
                  <option key={i.id} value={i.id}>{i.platform === 'instagram' ? `@${i.instagram_username || i.nome_instancia}` : i.nome_instancia}</option>
                ))}
              </select>
            </div>
          )}

          {/* Datas */}
          <div className="flex items-center gap-2">
            <Calendar className={`w-4 h-4 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`} />
            <input type="date" value={filtros.dataInicio || ''}
              onChange={(e) => onChange({ ...filtros, dataInicio: e.target.value })}
              className={inputCls} />
            <span className={darkMode ? 'text-gray-400' : 'text-gray-600'}>até</span>
            <input type="date" value={filtros.dataFim || ''}
              onChange={(e) => onChange({ ...filtros, dataFim: e.target.value })}
              className={inputCls} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltrosPeriodo;
